// @ts-check
import './filter-modal.scss';
import { h } from 'preact';
import { useRef, useEffect } from 'preact/hooks';

import CloseButton from '../CloseButton';

import RadioFilter from './components/RadioFilter/RadioFilter';
import CheckboxFilter from './components/CheckboxFilter/CheckboxFilter';
import RangeFilter from './components/RangeFilter/RangeFilter';

const { __, sprintf } = wp.i18n;

/**
 * @param {object} props
 * @param {string} props.mapId
 * @param {[]} props.filters
 * @param {boolean} props.isActive
 * @param {number} props.numberOfResults
 * @param {number} props.numberOfFiltersActive
 * @returns
 */
export default function FilterModal({
	mapId,
	children,
	filters,
	isActive,
	numberOfResults,
	numberOfFiltersActive,
	onFilterChangeHandler,
	onFilterResetHandler,
	onFiltersResetHandler,
	onCloseHandler,
	getMatchCountForFilter
}) {
	const scrollContainer = useRef(null);

	useEffect(() => {
		if (scrollContainer.current && scrollContainer.current.nodeType === 1) {
			scrollContainer.current.scrollTop = 0;
		}
	}, [isActive]);

	function renderFilter(data) {
		switch (data.type) {
		case 'radio':
			return <RadioFilter {...data} id={`${mapId}-${data.name}`} onChangeHandler={onFilterChangeHandler} onResetHandler={onFilterResetHandler} getMatchCount={getMatchCountForFilter} />;
		case 'checkbox':
			return <CheckboxFilter {...data} id={`${mapId}-${data.name}`} onChangeHandler={onFilterChangeHandler} onResetHandler={onFilterResetHandler} getMatchCount={getMatchCountForFilter} />;
		case 'range':
			return <RangeFilter {...data} id={`${mapId}-${data.name}`} onChangeHandler={onFilterChangeHandler} onResetHandler={onFilterResetHandler} />;
		}
	}

	return (
		<div class={'filter-modal-container' + (isActive ? ' is-active' : '')} aria-hidden={!isActive} disabled={!isActive}>
			<div class="filter-modal-header-container">
				<h2 class="filter-modal-name">{__('Filters', 'real-estate-project')}</h2>
				<CloseButton onClickHandler={onCloseHandler} theme="dark" />
			</div>
			<div class="filter-modal-results-header-container">
				{numberOfResults === 1 ?
					sprintf(__('%d result', 'real-estate-project'), numberOfResults) :
					sprintf(__('%d results', 'real-estate-project'), numberOfResults)}
				{numberOfFiltersActive > 0 ?
					<button onClick={onFiltersResetHandler} class="filter-modal-reset-filters-button">{__('Reset filters', 'real-estate-project')}</button> : ''}
			</div>
			<div ref={scrollContainer} class="filter-modal-viewport-container">
				<div class="filter-modal-viewport-container-inner">
					{children}
					<form>
						{filters.map(filter => (
							renderFilter(filter)
						))}
					</form>
				</div>
			</div>
			<div class="filter-modal-footer-container">
				<button disabled={numberOfResults === 0} class="filter-modal-show-results-button button" onClick={onCloseHandler}>
					{numberOfResults === 0 ?
						__('No results', 'real-estate-project') :
						numberOfResults === 1 ?
							sprintf(__('Show %d result', 'real-estate-project'), numberOfResults) :
							sprintf(__('Show %d results', 'real-estate-project'), numberOfResults)}
				</button>
			</div>
		</div>
	);
}
